import { Injectable } from '@angular/core';
import { Error } from '../../types/errors.type';
import { Router } from '@angular/router';
import { BehaviorSubject, throwError } from 'rxjs';
import { AppInsightsMonitoringService } from '../logging/appInsightsMonitoring.service';
import { UserSelectionsService } from '../user-selections/user-selections.service';
import { ThrowStmt } from '@angular/compiler';
import { UserSelections } from '../../types/user-details.type';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    error$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selections: UserSelections;

    constructor(private router: Router, private appInsights: AppInsightsMonitoringService, userSelections: UserSelectionsService) {
        this.selections = userSelections.selections;
    }

    /**
     * @description Given an Error object, perform the appropriate action.
     *
     * Out goal here is to present the user with an appropriate error message. We do this
     * by checking what response the API gave us.
     */
    handleError(error: Error) {
        var properties = {
            error: error,
            combinedModelName: null,
            modelTreeRef: null,
            start: null,
            startTime: null,
            url: null
        };

        if (this.selections.product != null) {
            properties.combinedModelName = this.selections.product.combinedModelName;
            properties.modelTreeRef = this.selections.product.modelTreeRef;
        }

        if (this.selections.startDate != null) {

            properties.start = this.selections.startDate;
            properties.startTime = this.selections.startTime;
        }
        if (this.router.routerState != null) {
            properties.url = this.router.routerState.snapshot.url;
        }

        var errorMessage;
        console.log(error);
        if (error.statusCode === 409 && error.url.includes('api/bookings') && error.method === 'POST') {
            errorMessage = "booking-slot-conflict";
            this.appInsights.logEvent(errorMessage, properties)
            this.error$.next('time_unavailable');
        } else if (error.statusCode === 400 && error.url.includes('api/bookings') && error.method === 'POST') {
                errorMessage = "guest-limit-breached";
                this.appInsights.logEvent(errorMessage, properties)
                this.error$.next('guest_limit');
        } else if (error.url.includes('api/bookings') && error.method === 'PATCH') {
            errorMessage = "cancellation_error";
            this.appInsights.logEvent(errorMessage, properties)
            this.error$.next('cancellation_error');
        } else {
            errorMessage = "generic_error";
            this.appInsights.logEvent(errorMessage, properties)
            this.error$.next('generic_error');
        }

        this.router.navigate(['/error'], { skipLocationChange: true });
        const result = throwError(new Error(`${errorMessage}, properties: ${JSON.stringify(properties)}`));
        result.subscribe(e => console.error(e));
    }
}
